document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.addEventListener("click", (event) => {
      $(".mini-cart-products").text("");
      var parent_menu = event.target.parentElement.parentElement.id.replace(
        "Details-",
        ""
      );
      var child_menu = document.getElementById(parent_menu);
      $(child_menu).toggleClass("open");
      $(".search-container").removeClass("open");
      $(".mini-cart-products").text("");
    });
  });
});
$(".open.header__icon--cart").on("click", function (event) {
  event.preventDefault();
});

$("#cart-icon-bubble").on("click", function (event) {
  event.preventDefault();
  $(".custom-child-menu").removeClass("open");
  $(".search-container").removeClass("open");
  $(".menu-mobile").removeClass("open");
  if (!$(this).hasClass("clicked")) {
    $(this).addClass("clicked");
    $.getJSON("/cart.js", function (cart) {
      console.log(cart);
      var item_count = cart["item_count"];
      var total_price = cart["total_price"] / 100;

      var cart_list = [];
      if (cart["items"].length > 0) {
        for (var i = 0; i < cart["items"].length; i++) {
          var item_id = cart["items"][i]["id"];
          var product_title = cart["items"][i]["product_title"];
          // var product_title = data['items'][i]['title'];
          var product_handle = cart["items"][i]["handle"];
          var quantity = cart["items"][i]["quantity"];
          var line_price = cart["items"][i]["price"] / 100;
          var url = cart["items"][i]["url"];
          var image_url = cart["items"][i]["image"];
          var variants = cart["items"][i]["variant_options"];
          var key = cart["items"][i]["key"];
          if (product_title == "Gift Wrap") {
            var product_url = product_title;
          } else {
            var product_url = '<a href="' + url + '">' + product_title + "</a>";
          }

          var options = [];
          for (var o = 0; o < variants.length; o++) {
            var selected = cart["items"][i]["variant_options"][o];
            if (selected !== "Default Title") {
              options.push(selected + " ");
            }
          }
          var selected_options = options.join("");

          cart_list.push(
            '<div class="cartpopup-item d-flex flex-row">\
	                      <div class="cartpopup-item-image">\
	                          <a href="' +
              url +
              '">\
	                              <img class="img-fluid d-block" src="' +
              image_url +
              '"  alt="' +
              product_title +
              '" />\
	                          </a>\
	                      </div>\
	                      <div class="cartpopup-item-content d-flex flex-column">\
	                          <h5>' +
              product_url +
              '</h5>\
	                          <span class="variant">' +
              selected_options +
              '</span>\
	                          <span class="price">' +
              line_price +
              ' ש״ח</span>\
	                          <!--<div class="quantity-box d-flex flex-row">' +
              quantity +
              '</div>-->\
	                          <div class="d-flex flex-row">\
	                              <a class="remove" href="/cart/change?id=' +
              key +
              '&amp;quantity=0">הסרה</a>\
	                          </div>\
	                      </div>\
	                      <!--<div class="col span_6">' +
              product_url +
              "<br>" +
              selected_options +
              '</div>\
	                      <div class="col span_3 text-right">$' +
              line_price +
              "<br>x " +
              quantity +
              '<input type="hidden" id="updates_' +
              item_id +
              '" value="' +
              quantity +
              '" />\
	                      </div>-->\
	                  </div>'
          );
        } // endfor
        cart_list.push(
          '<div class="cartpopup-footer d-flex flex-row">\
              <form action="/cart" method="post" id="cart-notification-form">\
                 <button class="button button--primary button--full-width" name="checkout">לתשלום</button>\
              </form>\
              <button type="button" class="link button-label close-minicart">להמשך רכישה</button>\
          </div>'
        );
        $(".mini-cart-products").html(cart_list.join(""));
        $("a#cart-icon-bubble").removeClass("closed");
        $(this).addClass("open");
      }
    });
  } else {
    $(this).removeClass("clicked");
    $(".mini-cart-products").text("");
    $("a#cart-icon-bubble").removeClass("open");
    $(this).addClass("closed");
  }
});
$(document).on("click", ".close-minicart", function (event) {
  $(".mini-cart-products").text("");
  $("#cart-icon-bubble").removeClass("clicked");
});

$(".search-trigger").on("click", function (event) {
  event.preventDefault();
  $(".search-container").toggleClass("open");
  $(".custom-child-menu").removeClass("open");
  $(".mini-cart-products").text("");
});

$(".mobile-menu-trigger").on("click", function (event) {
  event.preventDefault();
  $(".search-container").removeClass("open");
  $(".custom-child-menu").removeClass("open");
  $(".mini-cart-products").text("");
  $(".menu-mobile").toggleClass("open");
  $(".header-wrapper").toggleClass("menu-mobile-opened");
  if ($(".menu-mobile").hasClass("open")) {
    // $(".header-wrapper").addClass("menu-mobile-opened");
    $(".mobile-menu-trigger .icon-hamburger").hide();
    $(".mobile-menu-trigger .icon-close").show();
  } else {
    $(".mobile-menu-trigger .icon-hamburger").show();
    $(".mobile-menu-trigger .icon-close").hide();
    // $(".header-wrapper").removeClass("menu-mobile-opened");
  }
});

$(document).ready(function () {
  $(window).resize(function () {
    $(".search-container").removeClass("open");
    $(".custom-child-menu").removeClass("open");
    $(".mini-cart-products").text("");
    $(".menu-mobile").removeClass("open");
  });
});
